'use client'

import { useCallback } from 'react'
import Analytics from '@/utils/analytics'

export type EventData = {
  category: string
  status?: string
  payment_id?: string
  flow: string
  version: number
  merchantName?: string
  reference?: string
  amount?: string
  selected_currency?: string
  protocol_type?: string
  error?: string
  variant?: string
  experiment_id?: number
  jira_id?: string
  from_locale?: string
  to_locale?: string
  returnUrl?: string
  user_id?: string
  meshAction?: string
  meshActionPayload?: Record<string, unknown>
  merchant_id?: string
  email?: string
  theme?: string
}

const useTrackEvent = () => {
  return useCallback((eventName: string, eventData: EventData) => {
    Analytics.AMP.identify()
    Analytics.HotJar.identify(eventData?.payment_id || '', { ...eventData })
    Analytics.AMP.track(eventName, { ...eventData })
    Analytics.HotJar.track(eventName)
    Analytics.AMP.setInfo('payment_id', eventData?.payment_id || '')
    Analytics.AMP.setInfo('user_id', eventData?.user_id || '')
    Analytics.AMP.setInfo('merchant_id', eventData?.merchant_id || '')
    Analytics.AMP.setInfo('merchant_name', eventData?.merchantName || '')
    Analytics.AMP.setUserProperties({
      payment_id: eventData?.payment_id || '',
      user_id: eventData?.user_id || '',
      merchant_id: eventData?.merchant_id || '',
      merchant_name: eventData?.merchantName || '',
    })
  }, [])
}

export default useTrackEvent
